var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "8 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8507 20.0178C12.8507 11.6512 19.6416 4.86865 28.0083 4.86865C36.3749 4.86865 43.1658 11.6512 43.1658 20.0178C43.1658 28.3845 36.3749 35.167 28.0083 35.167C19.6416 35.167 12.8507 28.3845 12.8507 20.0178Z",
    fill: "url(#paint0_linear_595_8070)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6735 20.0178C14.6735 12.6592 20.647 6.69144 28.0083 6.69144C35.3695 6.69144 41.343 12.6592 41.343 20.0178C41.343 27.3765 35.3695 33.3442 28.0083 33.3442C20.647 33.3442 14.6735 27.3765 14.6735 20.0178Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3.64557
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3912 20.2039C16.3912 13.6889 21.6792 8.40747 28.1942 8.40747C34.7092 8.40747 39.9972 13.6889 39.9972 20.2039C39.9972 26.7189 34.7092 32.0004 28.1942 32.0004C21.6792 32.0004 16.3912 26.7189 16.3912 20.2039Z",
    fill: "url(#paint1_linear_595_8070)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_595_8070",
    x1: 32.3701,
    y1: 35.167,
    x2: 22.8185,
    y2: 8.21509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#87704F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_595_8070",
    x1: 31.5907,
    y1: 32.0004,
    x2: 24.153,
    y2: 11.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#87704F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC6C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronze-medal.af73aba6079c8bda497f0944abb51223.svg";
export { ForwardRef as ReactComponent };